<template>

  <div class="container">


    <p>上传后的 获得 的图片路径是：</p><h2>{{imagePath}}</h2>
    <br>
    <div style="height: 300px;width: auto; max-width: 600px; background-color: #cbcbcb;">
      <img  height="300px" :src="imagePath">
    </div>
  
    <br>
    <a v-if="imagePath!==''" :href="imagePath">点击查看</a>
    <el-upload ref="imageListUpload" class="select-uploader" multiple :action="IMAGE_UPLOAD_PRO_URL"
               :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file"
               :headers="header">
      <el-button type="primary">上传图片</el-button>
    </el-upload>

  </div>
</template>

<script>

import {IMAGE_UPLOAD_WEB3_STORAGE_URL} from "../../common/const";





export default {
  components: {

  },
  data() {
    return {
      IMAGE_UPLOAD_PRO_URL: IMAGE_UPLOAD_WEB3_STORAGE_URL,

      header: {
        toke: localStorage.getItem('token'),
        platform: 'admin',
      },


      imagePath:"",

    };
  },

  computed: {},
  created() {

  },
  methods: {


    //图片上传
    handleAvatarSuccess(res, file, fileList) {
      if (res.code===1){
        this.$message.success("上传成功")
        this.imagePath=res.data.uri
      }else {
        this.$message.error("上传失败")
      }

    },
    beforeAvatarUpload(file) {
      // loads.open('.avatar-uploader .el-upload', '上传中')
      const _this = this

    },


  }
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  font-size: 28px;
  line-height: 100px;
}

.img-box {
  width: 100px;
  height: 100px;
  border: 1px solid #eeeeee;
  line-height: 110px;
  text-align: center;
  margin-top: 10px;
}

.desc {
  margin-left: 20px;
}

.check {
  display: inline-block;
  margin-left: 20px;
}

.check1 {
  display: inline-block;
  margin-right: 15px;
}

.el-form-item__conten {
  width: 100%;
}

.infotable {
  width: 100%;
}

.el-icon-circle-plus-outline {
  color: blue;
  font-size: 20px;
  /* margin-left: 20px; */
}

.el-icon-remove-outline {
  color: blue;
  font-size: 20px;
  margin-left: 20px;
}

.form-box {
  width: 100%;
}

.left {
  margin-left: 0;
}

.button {
  border: none;
  background-color: #ffffff;
  outline: none;
  display: flex;
  align-self: end;
  margin-top: 10px;
}

.blue {
  cursor: pointer;
  color: blue;
  margin-left: 10px;
}

able th > .cell {
  display: flex;
  align-items: center;
}

.inline {
  width: 100%;
}

.inline >>> .el-input__inner {
  width: 60px;
}

.split {
  font-weight: 900;
  width: 100%;
  line-height: 40px;
  background-color: #dddddd;
  margin: 20px 0;
  padding-left: 20px;
}

/* 文本编辑样式 */
.editor {
  width: 60%;
  height: 600px;
}

.editor >>> .ql-container {
  min-height: 300px;
}

/* 开关样式 */

.exio-switch >>> .el-switch__core {
  height: 20px !important;
  line-height: 20px !important;
  width: 46px !important;
}

.exio-switch >>> .el-switch__label--left {
  position: relative;
  left: 46px;
  color: #fff;
  z-index: -1111;
}

.exio-switch >>> .el-switch__label--right {
  position: relative;
  right: 46px;
  color: #fff;
  z-index: -1111;
}

.exio-switch >>> .el-switch__label--right.is-active {
  z-index: 1111;
  color: #fff !important;
}

.exio-switch >>> .el-switch__label--left.is-active {
  z-index: 1111;
  color: #fff !important;
}

.exio-switch >>> .el-switch__core:after {
  top: 2px;
}

.avatar-uploader {
  margin-top: 10px;
}

/* .input-span {
    position: relative;
    display: inline-block;
} */

.deletebtn {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  font-size: 20px;
}

.input-span:hover .deletebtn {
  opacity: 1;
}

.spec-key {
  position: relative;
}

.spec-key:hover .spec-key-remove {
  display: block;
}

.spec-key .spec-key-remove {
  display: none;
  position: absolute;
  top: 12px;
  left: 200px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  width: 18px;
  height: 18px;
  font-size: 14px;
  line-height: 16px;
  background: hsla(0, 0%, 60%, 0.6);
  border-radius: 10px;
  text-indent: 0;
}

.specifbox {
  margin-top: 10px;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
}

.ql-snow .ql-editor img {
  display: block !important;
}
</style>
